"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _material = require("@mui/material");
var _Icons = require("./Icons");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var StyledAvatar = (0, _material.styled)(_material.Avatar)(function (_ref) {
  var theme = _ref.theme;
  return {
    backgroundColor: 'transparent',
    '& .MuiSvgIcon-root': {
      color: theme.palette.text.primary
    }
  };
});
function SurfaceAvatar(_ref2) {
  var icon = _ref2.icon,
    backButton = _ref2.backButton;
  var history = (0, _reactRouterDom.useHistory)();
  if (backButton) {
    if (backButton.to) {
      return /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
        size: "medium",
        component: _reactRouterDom.Link,
        to: backButton.to
      }, /*#__PURE__*/_react["default"].createElement(_Icons.BackIcon, null));
    }
    return /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
      size: "medium",
      onClick: history.goBack
    }, /*#__PURE__*/_react["default"].createElement(_Icons.BackIcon, null));
  }
  return /*#__PURE__*/_react["default"].createElement(StyledAvatar, {
    variant: "circular"
  }, icon);
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(SurfaceAvatar);